/*eslint-disable*/
import api from '../'

class StageApi {

  static show(id) {
    return api.axios.get('/olympiad/stage/' + id)
      .then(response => response.data.stage);
  }

  static update(id, params) {
    return api.axios.put('/olympiad/stage/' + id, params)
      .then(response => response.data.stage);
  }
}

export default StageApi;
